import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/agent-management'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: { title: '首页看板' }
  },
  {
    path: '/agent-management',
    name: 'AgentManagement',
    component: () => import('@/views/AgentManagement.vue'),
    meta: { title: 'AI助理团队' }
  },
  {
    path: '/agent-edit/:id?',
    name: 'AgentEdit',
    component: () => import('@/views/AgentEdit.vue'),
    meta: { title: '编辑AI助理' }
  },
  {
    path: '/quick-start',
    name: 'QuickStart',
    component: () => import('@/components/QuickStartCollaboration.vue'),
    meta: { title: '快速启动多智能体协作' }
  },
  {
    path: '/green-operations',
    name: 'GreenOperations',
    redirect: '/green-operations/health-safety',
    meta: { title: '绿色运营' },
    children: [
      {
        path: 'health-safety',
        name: 'HealthSafety',
        component: () => import('@/views/green-operations/HealthSafety.vue'),
        meta: { title: '健康安全' }
      },
      {
        path: 'green-design',
        name: 'GreenDesign',
        component: () => import('@/views/green-operations/GreenDesign.vue'),
        meta: { title: '绿色设计' }
      },
      {
        path: 'carbon-management',
        name: 'CarbonManagement',
        component: () => import('@/views/green-operations/CarbonManagement.vue'),
        meta: { title: '能碳管理' }
      },
      {
        path: 'supply-chain',
        name: 'SupplyChain',
        component: () => import('@/views/green-operations/SupplyChain.vue'),
        meta: { title: '绿色供应链' }
      },
      {
        path: 'product-responsibility',
        name: 'ProductResponsibility',
        component: () => import('@/views/green-operations/ProductResponsibility.vue'),
        meta: { title: '产品责任' }
      }
    ]
  },
  {
    path: '/insights',
    name: 'Insights',
    component: () => import('@/views/Insights.vue'),
    meta: { title: '洞察分析' }
  },
  {
    path: '/incident-reports',
    name: 'IncidentReports',
    component: () => import('@/views/IncidentReports.vue'),
    meta: { title: '事件汇报' }
  },
  {
    path: '/improvement-actions',
    name: 'ImprovementActions',
    component: () => import('@/views/ImprovementActions.vue'),
    meta: { title: '改进行动' }
  },
  {
    path: '/templates',
    name: 'Templates',
    component: () => import('@/views/Templates.vue'),
    meta: { title: '模版中心' }
  },
  {
    path: '/training',
    name: 'Training',
    component: () => import('@/views/Training.vue'),
    meta: { title: '培训' }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/Settings.vue'),
    meta: { title: '设置' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta?.title) {
    document.title = `${to.meta.title} - ArkSus`
  }
  next()
})

export default router